<script>
export default {
    name: 'NavPill',
    props: {
        identifier: null,
        active: Boolean,
        first: Boolean,
        sm: Boolean,
        visible: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        scrollTo() {
            return this.first
                ? {
                      el: `#menuCategory-${this.identifier}`,
                      offset: -140,
                  }
                : `#menuCategory-${this.identifier}`
        },
    },
}
</script>

<template lang="pug">
.nav-item(v-if="identifier" :class="{'hide-link': !visible}")
    router-link.btn.btn-dark.btn-pill(
        :class="{'active': active, 'btn-xs': sm}"
        :to="{params: {menu: first ? undefined : identifier}, query: $route.query}"
        v-scroll-to="scrollTo"
        active-class="active"
        replace
        exact)
        slot
</template>
